<template>
  <div
    class="font-weight-bold d-none d-md-block message"
    v-if="typeof this.data !== 'undefined' && JSON.parse(this.data).show"
  >
    Scheduled maintenance: Our system will be down for maintenance on
    <span class="date">{{ JSON.parse(this.data).date | formatDateOnly }} </span>
    from <span class="date"> {{ JSON.parse(this.data).startTime }} </span> to
    <span class="date">{{ JSON.parse(this.data).endTime }}</span> EST.
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: false
    }
  }
};
</script>

<style scoped>
.message {
  font-size: 0.8rem;

  @media (min-width: 1116px) {
    font-size: 0.9rem;
  }
  @media (min-width: 1300px) {
    font-size: 1rem;
  }
}
.date {
  color: #363abb;
  font-weight: bold;
}
</style>
